export default "__VITE_PUBLIC_ASSET__1d9e1de8__"